/* eslint-disable no-unused-vars */
/**
 * Provides a single instace of an AWS object, S3, etc
 * @file 
 * @author Benjamin Listwon
 */

import AWS from 'aws-sdk'
// import { get as idbGet } from 'idb-keyval'


// !!!!!!! TODO: This goes in .env !!!!!!!!
const bucketName = process.env.VUE_APP_AWS_BUCKET_NAME
const bucketRegion = process.env.VUE_APP_AWS_BUCKET_REGION
const IdentityPoolId = process.env.VUE_APP_AWS_IDENTITY_POOL_ID

//
// Configure the AWS Instance
//
AWS.config.update({
	region: bucketRegion,
	credentials: new AWS.CognitoIdentityCredentials({
		IdentityPoolId: IdentityPoolId
	})
})

/**
 * An instance of S3
 * @constant
 * @type {object}
 */
const s3 = new AWS.S3({
	apiVersion: '2006-03-01',
	params: {Bucket: bucketName}
})

//
// Keeping in case I want to put this in LS
//
// if (idbGet(process.env.VUE_APP_SILA_2_USER_TOKEN)) {
// 	axios.defaults.headers.common['Authorization'] = 'Bearer ' + idbGet(process.env.VUE_APP_SILA_2_USER_TOKEN)
// }

export default s3